import { experimentalStyled } from '@material-ui/core/styles';

const LogoRoot = experimentalStyled('svg')``;

const LogoLight = (props) => (
  <LogoRoot
    height="37"
    version="1.1"
    viewBox="0 0 200 37"
    width="200"
    {...props}
  >
    <svg
      id="jb-logo-light"
      className="jb-logo logo-light"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1100 200"
      style={{
        enableBackground: 'new 0 0 1100 200',
      }}
      xmlSpace="preserve"
      {...props}
    >
      <style type="text/css">
        {
          '\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#2D4DA0;}\n\t.st2{fill:#FFFFFF;}\n\t\n'
        }
      </style>
      <g>
        <g>
          <g>
            <g>
              <g>
                <rect
                  x={704.1}
                  y={67.7}
                  className="st0"
                  width={38.1}
                  height={129.5}
                />
              </g>
            </g>
            <g>
              <rect
                x={704.1}
                y={10.7}
                className="st0"
                width={38.1}
                height={38.1}
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M243,51.5c-40.3,0-72.8,32.7-72.8,72.8c0,40.3,32.7,72.8,72.8,72.8c40.3,0,72.8-32.7,72.8-72.8 C315.9,84.2,283.3,51.5,243,51.5z M243,159.1c-19.2,0-34.8-15.7-34.8-34.8s15.6-34.8,34.8-34.8c19.2,0,34.8,15.6,34.8,34.8 S262.3,159.1,243,159.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M411.2,51.5c-40.3,0-72.8,32.7-72.8,72.8c0,40.3,32.7,72.8,72.8,72.8c40.3,0,72.8-32.7,72.8-72.8 S451.5,51.5,411.2,51.5z M411.2,159.1c-19.2,0-34.8-15.7-34.8-34.8s15.7-34.8,34.8-34.8c19.2,0,34.8,15.6,34.8,34.8 S430.4,159.1,411.2,159.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                className="st0"
                points="109.7,10.7 147.8,10.7 147.8,10.7  "
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M590.8,51.5c-12.6,0-24.4,3.2-34.8,8.8V8.9h-38.1V123l0,0c0,0.5,0,0.9,0,1.4c0,40.3,32.7,72.8,72.8,72.8 c40.3,0,72.8-32.7,72.8-72.8C663.6,84.2,631,51.5,590.8,51.5z M590.8,159.1c-19.2,0-34.8-15.7-34.8-34.8s15.6-34.8,34.8-34.8 c19.2,0,34.8,15.6,34.8,34.8S609.9,159.1,590.8,159.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="st0"
                d="M782.5,124.4c0,40.3,32.7,72.8,72.8,72.8c40.3,0,72.8-32.7,72.8-72.8c0-0.5,0-0.9,0-1.4l0,0V8.9h-38.1v51.4 c-10.3-5.6-22.2-8.8-34.8-8.8C815.1,51.5,782.5,84.2,782.5,124.4z M820.5,124.4c0-19.2,15.7-34.8,34.8-34.8s34.8,15.6,34.8,34.8 c0,19.2-15.6,34.8-34.8,34.8C836.2,159.1,820.5,143.6,820.5,124.4z"
              />
            </g>
          </g>
          <g>
            <path
              className="st0"
              d="M147.7,10.7v114.8c-0.4,27.1-15.8,50.7-38.1,62.8c-10.3,5.6-22.2,8.8-34.8,8.8c-39.9,0-72.2-32-72.8-71.7 h38.1c0.6,18.7,15.9,33.5,34.7,33.5s34.1-15,34.8-33.5V48.7H74.9v-38H147.7z"
            />
          </g>
        </g>
        <g>
          <circle
            className="st1"
            cx={1013.3}
            cy={55.4}
            r={52.6}
          />
        </g>
        <g>
          <path
            className="st2"
            d="M975.4,65.7c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.5,0.1-0.8,0.4-1.1s0.7-0.4,1.1-0.4c0.4,0,0.8,0.1,1.1,0.4 c0.3,0.3,0.4,0.7,0.4,1.1c0,0.5-0.1,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5C976.1,66.2,975.7,66,975.4,65.7z"
          />
          <path
            className="st2"
            d="M983.2,53.3c0.7-1.3,1.7-2.2,2.8-2.9c1.2-0.7,2.5-1.1,4.1-1.1c2,0,3.7,0.5,5,1.5s2.1,2.3,2.5,4.1h-2.2 c-0.3-1.2-0.9-2.1-1.8-2.7c-1-0.7-2-1-3.5-1c-1.1,0-2,0.3-2.9,0.8s-1.6,1.3-2,2.2c-0.5,1-0.8,2.2-0.8,3.6c0,1.4,0.3,2.6,0.8,3.7 c0.5,1.1,1.2,1.8,2,2.2c0.9,0.5,1.8,0.8,2.9,0.8c1.4,0,2.5-0.3,3.5-1c1-0.7,1.6-1.6,1.8-2.8h2.2c-0.4,1.7-1.3,3-2.5,4.1 c-1.4,1-3,1.6-5,1.6c-1.6,0-2.9-0.4-4.1-1.1c-1.2-0.7-2.1-1.7-2.8-2.9c-0.7-1.3-1-2.7-1-4.5C982.1,56.2,982.5,54.6,983.2,53.3z"
          />
          <path
            className="st2"
            d="M1005.9,65.2c-1.3-0.7-2.2-1.7-2.9-2.9s-1.1-2.7-1.1-4.5c0-1.7,0.4-3.2,1.1-4.5c0.7-1.3,1.7-2.2,2.9-2.9 c1.3-0.7,2.6-1.1,4.2-1.1c1.6,0,2.9,0.4,4.2,1.1c1.3,0.7,2.2,1.7,2.9,2.9c0.7,1.3,1.1,2.7,1.1,4.5c0,1.7-0.4,3.1-1.1,4.5 c-0.7,1.3-1.8,2.2-2.9,2.9c-1.3,0.7-2.6,1.1-4.2,1.1C1008.6,66.3,1007.2,65.9,1005.9,65.2z M1013,63.6c0.9-0.5,1.7-1.3,2.2-2.2 s0.9-2.2,0.9-3.6c0-1.4-0.3-2.6-0.9-3.6s-1.3-1.8-2.2-2.2c-0.9-0.5-1.9-0.8-3-0.8s-2,0.3-3,0.8c-0.9,0.5-1.7,1.3-2.2,2.2 s-0.8,2.2-0.8,3.6c0,1.4,0.3,2.6,0.8,3.6s1.3,1.8,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8C1011,64.4,1012.2,64.1,1013,63.6z"
          />
          <path
            className="st2"
            d="M1047.9,51.2c1.2,1.2,1.8,2.9,1.8,5.3V66h-2v-9.3c0-1.8-0.4-3.1-1.3-4.1s-2-1.4-3.5-1.4 c-1.6,0-2.7,0.5-3.7,1.6c-0.9,1-1.4,2.5-1.4,4.5V66h-2v-9.3c0-1.8-0.4-3.1-1.3-4.1c-0.9-1-2-1.4-3.5-1.4c-1.6,0-2.7,0.5-3.7,1.6 c-1,1.1-1.4,2.5-1.4,4.5V66h-2.1V49.6h2.1v2.8c0.5-1,1.3-1.8,2.2-2.3c1-0.5,2-0.8,3.2-0.8c1.5,0,2.6,0.3,3.7,1 c1.1,0.7,1.8,1.7,2.3,3c0.5-1.3,1.2-2.3,2.2-3c1.1-0.7,2.2-1.1,3.6-1.1C1045,49.3,1046.6,49.9,1047.9,51.2z"
          />
        </g>
      </g>
    </svg>
  </LogoRoot>
);

export default LogoLight;
